import styled from 'styled-components'
import { Loading, MediaLightboxType } from 'src/components'
import { ArrivedFrom } from 'src/components/mediaLightbox/mediaLightbox.types'
import { useMediaLightbox } from 'src/context'
import { CommentEndpoints } from 'src/client/comment/constants'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import { useUser } from 'src/hook/useUser'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'

export const ContentImage = styled.img`
  max-width: 50%;
  max-height: 29.6875rem;
  border: 1px solid var(--gray-200);
  margin-top: 0.375rem;

  @media screen and (max-width: 768) {
    max-height: 17.25rem;
  }

  @media screen and (max-width: 576) {
    max-height: 12.5rem;
  }
`

ContentImage.displayName = 'ContentImage'

export const Fade = styled.div`
  z-index: 99;
  top: 0;
  left: 0;
  background-color: rgba(230, 233, 237, 0.8);
`

Fade.displayName = 'Fade'

export const Modal = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
`

Modal.displayName = 'Modal'

export const Close = styled.button`
  top: 0.938rem;
  right: 0.938rem;
  z-index: 10;
  padding: 0.313rem 0.5rem;
`

Close.displayName = 'Close'

export const Img = styled.img`
  max-width: 100vw;
  max-height: 100vh;
`

Img.displayName = 'Img'

export type ImagePreviewProps = {
  newsId: number
  commentId: number
  arrivedFrom: ArrivedFrom
  mediaWidth?: number
  mediaHeight?: number
}

const ImagePreview = ({
  newsId,
  commentId,
  mediaWidth,
  mediaHeight,
  arrivedFrom
}: ImagePreviewProps) => {
  const { sendDataHubConsume } = useSendDataHubConsume()
  const { authStatus } = useUser()
  const { onOpenLightbox } = useMediaLightbox()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const baseUrl = isUnauthenticated
    ? CommentEndpoints.getPublicCommentImage(newsId, commentId)
    : CommentEndpoints.getCommentImage(newsId, commentId)

  const { data: commentMediaSrc, isLoading: isLoadingCommentMedia } = useHotRequest<{
    data: string
  }>(baseUrl, {
    cacheKey: [baseUrl],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
    params: {
      redirect: false,
      dimensions: `${mediaWidth}x${mediaHeight}`
    },
    queryOptions: {
      ...DEFAULT_CACHE_CONFIG
    }
  })

  const handleOpenModalImage = () => {
    onOpenLightbox({
      type: MediaLightboxType.IMAGE,
      src: commentMediaSrc?.data,
      arrivedFrom,
      postId: newsId,
      commentId: commentId
    })

    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.CLICK_TO_VIEW_A_IMAGE_ON_COMMENT,
        screenName: ScreenNames.COMMUNITY_POST_COMMENT,
        componentName: ComponentNames.COMMENT_ITEM
      }
    })
  }

  return (
    <>
      {isLoadingCommentMedia ? (
        <div className="_w-full _d-flex _align-items-center _justify-content-center">
          <Loading />
        </div>
      ) : (
        <div className="_cursor-pointer" onClick={handleOpenModalImage}>
          <ContentImage
            data-test="content-image"
            src={commentMediaSrc?.data}
            className="_w-auto _h-auto _rounded-lg"
          />
        </div>
      )}
    </>
  )
}

export default ImagePreview
